import React from "react";
import franchiseImg from "../../assets/images/franchising.jpg"; // Replace with actual image path

const Franchise = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="bg-pink-100 py-20">
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div>
            <h1
              className="text-5xl font-bold text-pink-600 mb-6"
              style={{ fontFamily: "Barlow Semi Condensed" }}
            >
              Own the Pink Help Portal in Your Country or Category
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Become the exclusive franchisee of a Pink Page — and gain control over
              advertising, partnerships, and premium listings in your country or focus category.
            </p>
            <p className="text-md text-gray-700 leading-relaxed">
              With Pink Help’s global reputation and trusted platform, you’ll be at the center of
              women-focused impact and opportunity — while building your own revenue stream.
            </p>
          </div>

          {/* Image */}
          <div className="mt-16">
            <img
              src={franchiseImg}
              alt="Pink Help Global Franchise"
              className="rounded-3xl shadow-lg text-center"
            />
          </div>
        </div>
      </div>

      {/* Opportunities Section */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-6 space-y-16">
          {/* Opportunities */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">Opportunities Available For</h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg text-gray-700 list-disc list-inside font-medium max-w-4xl">
              <li>Entire Country Control (e.g., Pink Page Kenya, Pink Page France)</li>
              <li>Category Ownership (e.g., Legal UAE, Health Pakistan)</li>
            </ul>
          </div>

          {/* Benefits */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">Franchise Benefits</h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg text-gray-700 list-disc list-inside font-medium max-w-4xl">
              <li>Recurring revenue from advertisers in your region</li>
              <li>Use of Pink Help’s trusted global brand</li>
              <li>Access to full backend & operational panel</li>
              <li>Official license from Women of the World, Inc.</li>
            </ul>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <h3 className="text-2xl font-bold text-pink-600 mb-2">Limited Opportunities Per Country</h3>
            <p className="text-gray-700 mb-6">Apply now to secure your territory or category.</p>

            {/* Simple Form */}
            <form className="bg-pink-50 p-8 max-w-3xl mx-auto rounded-xl shadow-md space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Full Name"
                  className="p-3 rounded border border-gray-300 w-full"
                  required
                />
                <input
                  type="text"
                  placeholder="Country"
                  className="p-3 rounded border border-gray-300 w-full"
                  required
                />
              </div>
              <input
                type="text"
                placeholder="Category (Optional)"
                className="p-3 rounded border border-gray-300 w-full"
              />
              <textarea
                placeholder="Tell us about your background"
                className="p-3 rounded border border-gray-300 w-full"
                rows={4}
                required
              ></textarea>
              <input
                type="text"
                placeholder="Are you ready to invest?"
                className="p-3 rounded border border-gray-300 w-full"
              />

              <button
                type="submit"
                className="bg-pink-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-pink-700 transition"
              >
                Submit Franchise Application
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Franchise;
